// Bayo theme — light interactions
(function(){
  // quantity steppers
  document.addEventListener('click', function(e){
    var b=e.target.closest('[data-qty]'); if(!b) return;
    var wrap=b.closest('.stepper'); var input=wrap.querySelector('input');
    var v=parseInt(input.value)||1; v += (b.dataset.qty==='up'?1:-1); if(v<1)v=1;
    input.value=v; input.dispatchEvent(new Event('change',{bubbles:true}));
  });
})();
